export default __webpack_public_path__ + "static/media/affligem_background_xl2.a39a9ae9.jpg";